module.exports = __webpack_public_path__ + "static/media/mbe-new-logo.87dc6ad5.png";